import templateUrl from 'emun.on-demand/templates/od-product-template-images.htm'
import resolve from 'ioc/resolve'

class ProductTemplateImagesController {
}

let ProductTemplateImagesComponent = {
    bindings: {
        images: '=',
        productTemplate: '<?',
        type: '&',
        onConfigureCompositeImage: '&',
        onAddImage: '&',
        onRemoveImage: '&',
        onMoveImageUp: '&',
        onMoveImageDown: '&'
    },
    controller: ProductTemplateImagesController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default ProductTemplateImagesComponent;